export default {
  ok: {
    en: 'Ok',
  },
  connectWallet: {
    en: 'Connect wallet',
  },
  changeNetwork: {
    en: 'Change network',
  },
  loading: {
    en: 'Loading',
  },
  approve: {
    en: 'Approve',
  },
  close: {
    en: 'Close',
  },
  tryAgain: {
    en: 'Try again',
  },
  placeBet: {
    en: 'Place a bet',
  },
  okay: {
    en: 'Okay',
  },
  gotIt: {
    en: 'Got it',
  },
  continue: {
    en: 'Continue',
  },
}
